import { IEvaluationCommand } from "@Evaluation/cqrs";
import { CriterionToAttributeMap } from "@Evaluation/AlternativesSurveys/types";

export class ExcludeScoringPanelistCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExcludeScoringPanelistCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;

	constructor(workspaceId: number, surveyId: number, projectUserId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExcludeScoringPanelistCommandV1, TCh.Domain.Evaluation'
	}
}
export class IncludeScoringPanelistCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.IncludeScoringPanelistCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;

	constructor(workspaceId: number, surveyId: number, projectUserId: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.IncludeScoringPanelistCommandV1, TCh.Domain.Evaluation'
	}
}
export class ChangeScoringPanelistVoteStrengthCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ChangeScoringPanelistVoteStrengthCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	OldVoteStrength: number;
	NewVoteStrength: number;

	constructor(workspaceId: number, surveyId: number, projectUserId: number, oldVoteStrength: number, newVoteStrength: number)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.OldVoteStrength = oldVoteStrength;
		this.NewVoteStrength = newVoteStrength;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ChangeScoringPanelistVoteStrengthCommandV1, TCh.Domain.Evaluation'
	}
}

export class SendEmailCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SendEmailCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUsersIds: number[];
	EmailSubject: string;
	EmailBody: string;

	constructor(workspaceId: number, surveyId: number, projectUsersIds: number[], emailSubject: string, emailBody: string)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUsersIds = projectUsersIds;
		this.EmailSubject = emailSubject;
		this.EmailBody = emailBody;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SendEmailCommandV1, TCh.Domain.Evaluation'
	}
}
export class ExportSurveyScoresToAttributesCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExportSurveyScoresToAttributesCommandV1, TCh.Domain.Evaluation';

	UserId: number;
	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	Mappings: CriterionToAttributeMap[]; 

	constructor(userId: number, workspaceId: number, projectId: number, evalModelId: number, surveyId: number, mappings: CriterionToAttributeMap[])
	{
		this.UserId = userId;
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.Mappings = mappings;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExportSurveyScoresToAttributesCommandV1, TCh.Domain.Evaluation'
	}
}

export class CreateSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.CreateSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	Name: string;
	Description: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, name: string, description: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.CreateSurveyCommandV1, TCh.Domain.Evaluation'
	}
}
export class UpdateSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.UpdateSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	Name: string;
	Description: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, name: string, description: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.Name = name;
		this.Description = description;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.UpdateSurveyCommandV1, TCh.Domain.Evaluation'
	}
}
export class DeleteSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.DeleteSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.DeleteSurveyCommandV1, TCh.Domain.Evaluation'
	}
}


export class IncludeSubSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.IncludeSubSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	SubSurveyId: number;
	VoteStrength: number;

	constructor(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number, voteStrength: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = masterSurveyId.toString();
		this.SubSurveyId = subSurveyId;
		this.VoteStrength = voteStrength;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.IncludeSubSurveyCommandV1, TCh.Domain.Evaluation'
	}
}
export class ChangeSubSurveyVoteStrengthCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ChangeSubSurveyVoteStrengthCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	SubSurveyId: number;
	VoteStrength: number;

	constructor(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number, voteStrength: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = masterSurveyId.toString();
		this.SubSurveyId = subSurveyId;
		this.VoteStrength = voteStrength;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ChangeSubSurveyVoteStrengthCommandV1, TCh.Domain.Evaluation'
	}
}
export class ExcludeSubSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExcludeSubSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	SubSurveyId: number;

	constructor(workspaceId: number, projectId: number, evalModelId: number, masterSurveyId: number, subSurveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = masterSurveyId.toString();
		this.SubSurveyId = subSurveyId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExcludeSubSurveyCommandV1, TCh.Domain.Evaluation'
	}
}


export class StartSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.StartSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.StartSurveyCommandV1, TCh.Domain.Evaluation'
	}
}
export class StopSurveyCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.StopSurveyCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.StopSurveyCommandV1, TCh.Domain.Evaluation'
	}
}


export class UpdateSurveyCriteriaCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.UpdateSurveyCriteriaCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	CriteriaIds: number[];

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, criteriaIds: number[])
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.CriteriaIds = criteriaIds;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.UpdateSurveyCriteriaCommandV1, TCh.Domain.Evaluation'
	}
}

export class UpdateSurveyAlternativesCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.UpdateSurveyAlternativesCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	AlternativeIds: number[];
	DescriptionTemplate: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, alternativeIds: number[], descriptionTemplate: string)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.AlternativeIds = alternativeIds;
		this.DescriptionTemplate = descriptionTemplate;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.UpdateSurveyAlternativesCommandV1, TCh.Domain.Evaluation'
	}
}

export class ExportAllScoringVotesToXlsCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExportAllScoringVotesToXlsCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExportAllScoringVotesToXlsCommandV1, TCh.Domain.Evaluation'
	}
}

export class ExportPanelistVotesToXlsCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExportPanelistVotesToXlsCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	ProjectId: number;
	EvalModelId: number;
	Id: string;
	ProjectUserId: number;

	constructor(workspaceId: number, projectId: number, evalModelId: number, surveyId: number, projectUserId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.ExportPanelistVotesToXlsCommandV1, TCh.Domain.Evaluation'
	}
}


export class SavePanelistVotesCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelistVotesCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	EvalModelId: number;
	Id: string;
	ProjectUserId: number;
	Votes: any[];

	constructor(workspaceId: number, evalModelId: number, surveyId: number, projectUserId: number, votes: any[])
	{
		this.WorkspaceId = workspaceId;
		this.EvalModelId = evalModelId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.Votes = votes;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelistVotesCommandV1, TCh.Domain.Evaluation'
	}
}


export class SavePanelistVoteCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelistVoteCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	QuestionId: number;
	VoteValue: number | null;
	VoteComment: string | null;

	constructor(workspaceId: number, surveyId: number, projectUserId: number, questionId: number, voteValue: number | null, voteComment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.QuestionId = questionId;
		this.VoteValue = voteValue;
		this.VoteComment = voteComment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelistVoteCommandV1, TCh.Domain.Evaluation'
	}
}

export class SavePanelistVoteCommentCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelistVoteCommentCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	ProjectUserId: number;
	QuestionId: number;
	Comment: string | null;

	constructor(workspaceId: number, surveyId: number, projectUserId: number, questionId: number, comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.ProjectUserId = projectUserId;
		this.QuestionId = questionId;
		this.Comment = comment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelistVoteCommentCommandV1, TCh.Domain.Evaluation'
	}
}


export class SavePanelVoteCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelVoteCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	QuestionId: number;
	VoteValue: number | null;
	VoteComment: string | null;

	constructor(workspaceId: number, surveyId: number, questionId: number, voteValue: number | null, voteComment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.QuestionId = questionId;
		this.VoteValue = voteValue;
		this.VoteComment = voteComment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelVoteCommandV1, TCh.Domain.Evaluation'
	}
}

export class SavePanelVoteCommentCommandV1 implements IEvaluationCommand
{
	$type: string = 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelVoteCommentCommandV1, TCh.Domain.Evaluation';

	WorkspaceId: number;
	Id: string;
	QuestionId: number;
	Comment: string | null;

	constructor(workspaceId: number, surveyId: number, questionId: number, comment: string | null)
	{
		this.WorkspaceId = workspaceId;
		this.Id = surveyId.toString();
		this.QuestionId = questionId;
		this.Comment = comment;
	}

	static matchType(cmd: IEvaluationCommand)
	{
		return cmd.$type == 'TCh.Domain.Evaluation.AlternativesSurveys.Commands.SavePanelVoteCommentCommandV1, TCh.Domain.Evaluation'
	}
}

